import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { DarkMode, LightMode } from '@mui/icons-material'
import { setThemeMode, useThemeMode } from '@resolvex/resolvex-sdk'

export const ThemeToggle = (): JSX.Element => {
  const themeMode = useThemeMode()
  const label =
    themeMode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'

  return (
    <Tooltip title={label}>
      <IconButton
        color="inherit"
        aria-label={label}
        onClick={() => setThemeMode(themeMode === 'dark' ? 'light' : 'dark')}
      >
        {themeMode === 'dark' ? (
          <LightMode color="action" />
        ) : (
          <DarkMode color="action" />
        )}
      </IconButton>
    </Tooltip>
  )
}
